import { motion } from 'motion/react';
import { Container, Kicker, Mark } from './primitives';

const METRICS = [
  {
    figure: '7',
    unit: 'aree in produzione',
    label: 'Commessa, contabilità analitica, paghe, personale, acquisti, gare e direzione. Non una demo, non una roadmap.',
  },
  {
    figure: '100+',
    unit: 'utenti attivi / giorno',
    label: 'Persone che aprono BOSS ogni giorno per lavorare — capocantiere, geometri, ufficio del personale.',
  },
  {
    figure: '70+',
    unit: 'cantieri',
    label: 'Seguiti oggi nel pilota con Almacis, a Pescara.',
  },
  {
    figure: '1',
    unit: 'pilota',
    label: 'In corso con Almacis. Aggiungeremo altri numeri quando avremo altri piloti da mostrare.',
  },
];

export function Metrics({ index = '04' }: { index?: string }) {
  return (
    <section className="relative border-t border-border py-28 md:py-36">
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <Kicker index={index} label="La prova" />
          <h2 className="boss-display mt-5 text-balance text-[44px] md:text-[64px]">
            Non è una demo. <Mark>È già al lavoro.</Mark>
          </h2>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-border bg-border md:grid-cols-2 lg:grid-cols-4">
          {METRICS.map((m, i) => (
            <motion.div
              key={m.label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="relative flex flex-col bg-background p-7"
            >
              <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-fg-disabled">
                · 0{i + 1}
              </div>
              <div className="mt-4 leading-none">
                <span className="text-[64px] font-light tracking-tight tabular-nums md:text-[80px]">
                  {m.figure}
                </span>
              </div>
              <div className="mt-2 text-[14px] leading-tight text-primary">{m.unit}</div>
              <p className="mt-6 text-pretty text-[13px] leading-[1.55] text-fg-2">{m.label}</p>
            </motion.div>
          ))}
        </div>

        <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-fg-disabled">
          ∗ In produzione presso Almacis · Pescara · aggiornato ottobre 2026.
        </p>
      </Container>
    </section>
  );
}
